// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TTYAt","categorylist":"Sidebar_categorylist__JYCHn","footer":"Sidebar_footer__J9-iw"};